<form [formGroup]="stepForm"
         class="mbs-wizard_form">
  <mbs-form-group>
    <mbs-input [id]="'host-server'"
               [validationWhitespace]="true"
               [label]="'wizards:select_host_server' | i18next"
               (change)="resetIsValidCredentials()"
               placeholder="127.0.0.1"
               name="server"
               formControlName="server"></mbs-input>
  </mbs-form-group>

  <mbs-form-group>
    <mbs-input [id]="'host-login'"
               [validationWhitespace]="true"
               [label]="'wizards:select_host_login' | i18next"
               (change)="resetIsValidCredentials()"
               name="login"
               formControlName="login"></mbs-input>
  </mbs-form-group>

  <mbs-form-group>
    <mbs-input #hostPassField
               [label]="'wizards:select_host_password' | i18next"
               name="Password"
               [placeholder]="'wizards:password_placeholder' | i18next"
               formControlName="password"
               [id]="'host-password'"
               [autocomplete]="'off'"
               [type]="passwordInputType"
               (blur)="passwordBlurHandler($event)"
               (buttonClick)="changeTypePassword()"
               readonly
               (focus)="passwordFocusHandler($event); hostPassField.readonly = false"
               (change)="resetIsValidCredentials()"
               [appendButtons]="[
                 {
                   icon: passwordInputType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash',
                   id: 'changeTypePasswordOnEncryptionOptions',
                   disabled: stepForm.get('password')?.value === InitialValue?.password || stepForm.get('password')?.disabled,
                   type: 'secondary'
                 }
               ]"
               [validationWhitespace]="true">
    </mbs-input>
  </mbs-form-group>

  <mbs-select *ngIf="isRestoreVMWare && hostsList?.length"
              formControlName="host"
              (change)="resetIsValidCredentials()"
              [attr.data-test-element]="elementSelectors.name.hostSelect"
              [appendTo]="'.modal-content'"
              [showRequiredMark]="false"
              [clearable]="false"
              [hideSelected]="false"
              [items]="hostsList"
              [id]="'restore-host'"
              [label]="'wizards:selectHost' | i18next"
              [placeholder]="'wizards:selectHostPlaceholder' | i18next"
              [searchable]="false"></mbs-select>

  <mbs-alert *ngIf="isRestoreVMWare && hostsList?.length && !value?.host"
             class="mb-0 mt-3"
             [attr.data-test-element]="elementSelectors.name.hostAlert"
             [type]="mbsPopupType.warning"
             [icon]="true">
    {{ 'wizards:hostAlert' | i18next }}
  </mbs-alert>
</form>
